import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import { Card } from "../../../../Units/Card.styled";
import {
  P2PTableTab,
  TabHeader,
  TableTab,
  TableTab2,
} from "../../../../Units/TabsAndLinkStyled";
import { withTheme } from "styled-components";
import { groupActivitiesByDaysOrMonth } from "../../../../../utils/specialFunctions";
import { connect } from "react-redux";

import { P } from "../../../../../UI toolkit/Text/Text";
import P2POrdersTable from "./P2POrdersTable";
import { useHistory } from "react-router-dom";
import DashboardHeader from "../../DashboardHeader";
import {
  getP2POrders,
  updateP2POrdersActiveStatus,
  updateP2POrdersActiveTab,
  updateP2pOrdersSearch,
} from "../../../../../store/Actions/P2PActions";
import { Select } from "../../../../../UI toolkit/Dropdown/Dropdown";
import caret_down from "../../../../../assets/images/caret-down1.svg";
import { SearchInput } from "../../../../../UI toolkit/Input/Input";
import search_icon from "../../../../../assets/images/search.svg";
import lodash from "lodash";

const P2POrders = ({
  location,
  theme,
  getOrders,
  orders,
  filters,
  activeTab,
  updateTab,
  updateStatus,
  activeStatus,
  loading,
  page,
  totalPages,
  updatePage,
  updateSearch,
  keyword,
}) => {
  const links = [
    { text: "Overview", tab: "overview" },
    { text: "Ads", tab: "ads" },
    { text: "Orders", tab: "orders" },
  ];

  const linkKeys = {
    all: 0,
    ads: 1,
    orders: 2,
  };

  const router = useHistory();
  const handleP2PTabChange = (tab) => {
    // updateActiveTab(links[tab].tab);

    console.log("tab", tab);

    console.log("dd", links[tab].tab);

    router.push(`/dashboard/p2p/${links[tab].tab}`);
  };
  const tabs = [
    { text: "All", value: "all" },
    { text: "Buy", value: "buy" },
    { text: "Sell", value: "sell" },
  ];

  const status = [
    { text: "All", value: "all" },
    { text: "Pending", value: "pending" },
    { text: "Completed", value: "completed" },
    { text: "Failed", value: "failed" },
  ];

  const tabKeys = {
    all: 0,
    active: 1,
    completed: 2,
    stopped: 3,
  };

  // const currentStatus = activeStatus[activeTab];
  // const currentPage = page[activeTab][currentStatus];
  // const totalPage = totalPages[activeTab][currentStatus];

  const handleTabChange = (tab) => {
    updateTab(tab);
  };

  const handleStatusChange = (status) => {
    console.log("status", status);

    updateStatus(status);
  };
  // const handleNextPage = () => {
  //   console.log(currentPage, totalPage);
  //   if (currentPage < totalPage - 1) {
  //     updatePage({
  //       tab: activeTab,
  //       status: currentStatus,
  //       value: currentPage + 1,
  //     });
  //   }
  // };

  // const prevButtonDisabled = () => {
  //   return !(currentPage > 0);
  // };

  // const nextButtonDisabled = () => {
  //   return !(currentPage < totalPage - 1);
  // };

  // const handlePrevPage = () => {
  //   if (currentPage > 0) {
  //     updatePage({
  //       tab: activeTab,
  //       status: currentStatus,
  //       value: currentPage - 1,
  //     });
  //   }
  // };

  useEffect(() => {
    getOrders();
  }, [getOrders, activeStatus, activeTab, page, keyword]);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>P2P Orders</title>
        <link rel="canonical" href={location.pathname} />
      </Helmet>
      <DashboardHeader>Peer-to-peer Orders</DashboardHeader>

      <div>
        <form className="lg:w-6/12 w-9/12 pr-5 ">
          <SearchInput
            placeholder="Search users"
            search_icon={search_icon}
            bg={"#FFFFFF"}
            color={"#646A86"}
            p={"8px 16px"}
            w={"100%"}
            callback={(e) => {
              lodash.debounce(function () {
                updateSearch(e.target.value);
              }, 1500)();
            }}
          />
        </form>
        <P2PTableTab
          margin
          tabs={links}
          activeTab={2}
          handleTab={handleP2PTabChange}
          p={"16px 0px"}
          boxShadow={"0px"}
          borderRadius={"0px"}
          activeBg={"#FAFBFD"}
          activeColor={"#005674"}
          color={"#646A86"}
          activeOutline={"none"}
          activeOutlineBottom={"2px solid #005674"}
          tailwindpad
          callback={(active) => {
            console.log("hello");
            console.log(active);
            // updateActiveTab(links[active].tab);
          }}
        />
      </div>

      <div className="pt-6">
        <Card>
          <TabHeader>
            <div className="lg:flex justify-between">
              <div className="lg:w-8/12">
                <TableTab2
                  margin
                  tabs={tabs}
                  activeTab={activeTab}
                  handleDispatch={handleTabChange}
                  callback={(active) => {
                    console.log(active);
                  }}
                />
              </div>
              <div className="lg:w-4/12 flex justify-end my-3 mx-3 lg:my-1.5 lg:mx-1.5 py-5 lg:py-0">
                <div className="w-6/12">
                  <Select
                    bgImg={caret_down}
                    // bgColor={"#112E46"}
                    // color={"#fff"}
                    bgColor={theme.colors.bg}
                    color={theme.colors.color}
                    border={"1px solid #fff"}
                    borderRadius={"4px"}
                    p={"5px 15px"}
                    data={status}
                    defaultValue={"-- Status --"}
                    properyToShow={"text"}
                    hoverBg={"#FFF"}
                    hoverColor={"#112E46"}
                    fontSize={"16px"}
                    callback={(option, idx, arr) => {
                      handleStatusChange(option.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </TabHeader>
          {/* <pre>{JSON.stringify(orders, null, 2)}</pre> */}
          <div className="px-0">
            <P2POrdersTable
              links1={groupActivitiesByDaysOrMonth(
                orders ? orders : null,
                "days"
              )}
            />
          </div>
          {/* <div>
            {!loading && (
              <div className="flex justify-between gap-2 items-center py-4 w-full">
                <p className=""></p>
                <div className="flex items-center">
                  <DefaultButton
                    bg={theme.colors.bg}
                    color={theme.colors.color}
                    p={"8px 16px"}
                    onClick={handlePrevPage}
                    disabled={prevButtonDisabled()}
                  >
                    Prev
                  </DefaultButton>
                  <div className="px-4">
                    <P color={"#646A86"} fontSize="16px" fontWeight="700">
                      Page {currentPage + 1} of{" "}
                      {totalPage !== 0 ? totalPage : 1}
                    </P>
                  </div>
                  <DefaultButton
                    bg={theme.colors.bg}
                    color={theme.colors.color}
                    p={"8px 16px"}
                    onClick={handleNextPage}
                    disabled={nextButtonDisabled()}
                  >
                    Next
                  </DefaultButton>
                </div>
              </div>
            )}
          </div> */}
        </Card>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.p2p.loading,
    error: state.p2p.error,
    orders: state.p2p.orders,
    activeStatus: state.p2p.p2pOrdersActiveStatus,
    page: state.p2p.userP2PPage,
    activeTab: state.p2p.p2pOrdersActiveTab,
    totalPages: state.p2p.userP2PTotalPages,
    keyword: state.p2p.p2pOrdersSearch,
  };
};

// Link Actions to component
const mapDispatchToProps = (dispatch) => {
  return {
    getOrders: (query) => dispatch(getP2POrders(query)),
    updateTab: (tab) => dispatch(updateP2POrdersActiveTab(tab)),
    updateStatus: (status) => dispatch(updateP2POrdersActiveStatus(status)),
    updateSearch: (keyword) => dispatch(updateP2pOrdersSearch(keyword)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTheme(P2POrders)));
